export const TYPE_TEXT = 'text';

export const TYPE_CHECKBOX = 'checkbox';

export const TYPE_RADIO = 'radio';

export const TYPE_TEL = 'tel';

export const QUESTION_TYPE_EDIT_UPSELL = 'EditUpsellProduct';